<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import userManager from './oidc-config';

export default {
  methods: {
    login() {
      userManager.signinRedirect();
    },
    logout() {
      userManager.signoutRedirect();
    }
  }
};
</script>
